export const MARKETS_INFO = [
  {
    symbol: 'inj',
    description:
      ' Injective is the blockchain built for finance. It is an open, interoperable layer-one blockchain powering next-generation DeFi applications, including decentralized spot and derivatives exchanges, prediction markets, lending protocols, and more. Injective uniquely provides powerful core financial infrastructure primitives that applications can leverage, including a fully decentralized MEV-resistant on-chain orderbook.'
  },
  {
    symbol: 'btc',
    description:
      'BTC is the original decentralized digital currency, enabling secure peer-to-peer transactions on a global network without banks or central authorities.'
  },
  {
    symbol: 'eth',
    description:
      'Ethereum is a decentralized open-source blockchain system featuring its own cryptocurrency, Ether (ETH), that works as a platform for numerous other cryptocurrencies and for the execution of decentralized smart contracts.'
  },
  {
    symbol: 'weth',
    description:
      'WETH is an Ethereum token representing Ethereum (ETH) that can be used on decentralized exchanges (DEXs) and DeFi applications built on the Ethereum blockchain, allowing for easier integration and trading.'
  },
  {
    symbol: 'xrp',
    description:
      'XRP is a cryptocurrency that intends to be used for efficient cross-border transactions.'
  },
  {
    symbol: 'bnb',
    description:
      'BNB is the native cryptocurrency of the Binance exchange, used for discounted trading fees, network transaction fees on Binance Chain, and access to exclusive features on the Binance platform.'
  },
  {
    symbol: 'pyth',
    description:
      'Pyth is a decentralized oracle network providing high-quality, tamper-proof price data for DeFi applications across multiple blockchains.'
  },
  {
    symbol: 'doge',
    description:
      'Originally created as a joke, Dogecoin is a lighthearted, community-driven cryptocurrency with a loyal following that has skyrocketed in popularity in recent years. Despite the comical nature of DOGE, the blockchain has low fees and fast block times.'
  },
  {
    symbol: 'kava',
    description:
      'Kava is a decentralized blockchain that combines the speed and interoperability of Cosmos with the developer power of Ethereum.'
  },
  {
    symbol: 'wmatic',
    description:
      'A wrapped version of MATIC, the native token of the Polygon network, facilitating DeFi transactions and gas fee payments on the Polygon network.'
  },
  {
    symbol: 'sei',
    description:
      'Sei is an open-source blockchain hosting a vibrant ecosystem of decentralized applications (dApps). Using proof-of-stake consensus and ground-breaking technologies like Twin Turbo Consensus and Parallelization, the Sei blockchain aims to give users a web2-like experience with all the benefits of web3 decentralization.'
  },
  {
    symbol: 'op',
    description:
      'Optimism is a layer-2 scaling solution for the Ethereum blockchain, allowing for faster and cheaper transactions.'
  },
  {
    symbol: 'avax',
    description:
      'Avalanche is a high-throughput smart contracts platform designed for fast, secure, and scalable DeFi applications.'
  },
  {
    symbol: 'arb',
    description:
      'Arbitrum is a layer-2 scaling solution for the Ethereum blockchain, offering faster and cheaper transactions.'
  },
  {
    symbol: 'link',
    description:
      'LINK is a decentralized oracle network providing secure and reliable data feeds for blockchain applications, enabling smart contracts to access off-chain data.'
  },
  {
    symbol: 'sol',
    description:
      'Solana is a high-performance blockchain platform designed for scalability and speed in DeFi, NFTs, and dApps.'
  },
  {
    symbol: 'kuji',
    description:
      'Kujira is a decentralized derivatives exchange built on Cosmos, offering leveraged yield farming and options trading.'
  },
  {
    symbol: 'jup',
    description:
      'Jupiter protocol is an aggregated liquidity protocol on Solana, enabling users to earn DeFi yields across various lending platforms.'
  },
  {
    symbol: 'tia',
    description:
      'Celestia is a layer-1 blockchain protocol designed to focus on modularity and scalability for rollup applications. It acts as a secure base layer for rollups, enabling them to inherit security from the Celestia network while achieving high transaction throughput.'
  },
  {
    symbol: 'bonk',
    description:
      'BONK is the social layer and community meme coin of Solana, with deep integrations as a utility token across a wide base of applications and protocols. Many credit BONK with being the first meme coin on Solana.'
  },
  {
    symbol: 'w',
    description:
      'Wormhole is an open-source blockchain development platform connecting the decentralized web, known mostly for their cross-chain bridging and messaging applications.'
  },
  {
    symbol: 'sui',
    description:
      'Sui is a first-of-its-kind layer-1 blockchain and smart contract platform designed to make digital asset ownership fast, private, secure, and accessible.'
  },
  {
    symbol: 'hdro',
    description:
      'Hydro Protocol is the ultimate infrastructure platform allowing users to customise yield and liquidity strategies on the Injective Network. Hydro combines Liquid Staking Derivatives (LSD) products and Real World Assets (RWA) to offer a specialized LSDFi product suite.'
  },
  {
    symbol: 'hinj',
    description:
      'hINJ is the liquid staked version of INJ on the Hydro Protocol. Holding hINJ may entitle holders to staking yield.'
  },
  {
    symbol: 'black',
    description:
      'Black Panther is a decentralised asset management protocol designed to help users achieve superior returns on their digital assets through intelligent vaults. Black Panther offers active trading strategies to provide alpha for its users.'
  },
  {
    symbol: 'dojo',
    description:
      'DojoSwap is a UniSwap-inspired automated market-maker (AMM) protocol implemented with smart contracts on the Injective blockchain. The protocol enables a decentralized on-chain exchange for various assets involved in the Injective ecosystem.'
  },
  {
    symbol: 'omni',
    description:
      'Omni is a blockchain purpose-built to connect all rollups securely through the use of restaking.'
  },
  {
    symbol: 'ena',
    description:
      'Ethena is a synthetic dollar protocol built on Ethereum that provides a crypto-native solution for money not reliant on traditional banking system infrastructure, alongside a globally accessible dollar denominated instrument - the "Internet Bond".'
  },
  {
    symbol: 'wif',
    description: 'Literally just a dog wif a hat.'
  },
  {
    symbol: 'ninja',
    description:
      "NINJA is the first memecoin on Injective. It's a dog, but he has nunchucks."
  },
  {
    symbol: 'axl',
    description:
      'Axelar is a web3 interoperability platform designed to connect all blockchains. Axelar gives developers the power to easily build their own connections, customizing security, latency and other cross-chain rules in an open framework.'
  },
  {
    symbol: 'stinj',
    description:
      'stINJ is a representation of INJ staked on Stride, which is a blockchain that provides liquidity for staked tokens.'
  },
  {
    symbol: 'andr',
    description:
      'Andromeda is an all on-chain and multi-chain suite of products, tools, and utilities enabled by a decentralized Operating System called aOS, or Andromeda Operating System. AndromedaOS is a revolutionary software layer that provides a massively abstracted environment and user experience for the next generation of blockchain innovators to create, develop and get paid.'
  },
  {
    symbol: 'qunt',
    description:
      'Quants is a PFP NFT collection launched by PRMR, a dynamic group of long-standing Injective community members. Representing traders within the Injective ecosystem, Quants aims to provide an entertaining entry point into the world of decentralized finance.'
  },
  {
    symbol: 'usde',
    description:
      "Ethena's synthetic dollar, USDe, provides a crypto-native, scalable solution for money achieved by delta-hedging Ethereum and Bitcoin collateral. USDe is fully-backed and free to compose throughout DeFi."
  },
  {
    symbol: 'kira',
    description:
      'KIRA is more than a meme. Kira’s vision is to provide safety tools to the Injective builders and opportunities to the KIRA stakers.'
  },
  {
    symbol: 'nonja',
    description:
      'NONJA is a memecoin on Injective, based on another memecoin, NINJA.'
  },
  {
    symbol: 'usdc',
    description:
      'Built for rapid, global payments and 24/7 financial markets, USDC is a regulated, digital currency that can always be redeemed 1:1 for US dollars.'
  },
  {
    symbol: 'zig',
    description:
      'Zignaly is a social investment platform that allows retail investors to invest with professional asset managers securely from within the Zignaly platform. Neither Zignaly nor the professional trader/wealth manager charges any upfront payment, and performance-based profits are automatically distributed to users and traders.'
  },
  {
    symbol: 'talis',
    description:
      'TALIS is a governance token for Talis and its ecosystem. It serves both as a voting token, enabling participation in the DAO and decisions that shape the Talis NFT marketplace.'
  },
  {
    symbol: 'xiii',
    description: 'The Injective memecoin by the nINJas, for the nINJas.'
  },
  {
    symbol: 'usdtkv',
    description: 'USDTkv is Cosmos-native USDT, issued on the Kava blockchain.'
  },
  {
    symbol: 'lvn',
    description:
      'Levana is a protocol for perpetual swaps, which are leveraged trading contracts. It aims to manage risk and provide benefits to both traders and liquidity providers.'
  },
  {
    symbol: 'whale',
    description:
      'Whale token generates non-inflationary yield from all the liquidity pools and flashloans vaults across IBC-enabled blockchains.'
  }
]

export const MARKETS_POWERED_BY_STORK = [
  '0xf99ac012c3e97f434fe0d0ba4948fef763635bb06de5e3c43abc7f1da7c427a8'
]

export const MARKETS_POWERED_BY_SQUARETOWER = [
  '0x56cb0ef0b9d59125373112523b0adfc446dff989268547fa1a3379a6f98f5efd'
]

export const HELIX_APP_STORE_LINK =
  'https://apps.apple.com/us/app/helix-trade-with-control/id6737353178'

export const HELIX_PLAY_STORE_LINK =
  'https://play.google.com/store/apps/details?id=com.injectivelabs.helixmobile'
